import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { APP_ICONS } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import CustomRangePicker from "../../../components/DateRangePicker";
import TextInput from "../../../components/TextInputs";
import { setDonationCurrentPage } from "../../../lib/slices/pagination/donationPageSlice";
import {
    setDonationEndDate,
    setDonationOrganization,
    setDonationStartDate,
} from "../../../lib/slices/searchKeysSlice";

export const DonationFilters = ({ fetchData }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["donation", "common"]);
    const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
    const pagination = useSelector((state) => state.donationPaginationReducer);

    return (
        <Stack
            p={2}
            direction={{ xs: "column", md: "row" }}
            alignItems="stretch"
            gap={1.25}
            bgcolor="primary.light"
        >
            <TextInput
                styleProps={{
                    width: { xs: "100%", md: "58%", xl: "58%" },
                    "& .MuiOutlinedInput-root": {
                        height: 42,
                    },
                }}
                InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} alt="" />}
                InputEndIcon={
                    searchKeys.donationOrganization && (
                        <CancelOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                dispatch(setDonationOrganization(""));
                            }}
                        />
                    )
                }
                placeholder={t("searchByOrganizationOrderIdAndUser", { ns: "common" })}
                value={searchKeys.donationOrganization}
                onChange={(e) => {
                    dispatch(setDonationOrganization(e.target.value));
                }}
            />

            <Stack
                direction="row"
                alignItems="stretch"
                sx={{
                    width: { xs: "100%", md: "42%", xl: "42%" },
                    minWidth: 0,
                }}
            >
                <CustomRangePicker
                    startDate={searchKeys.donationStartDate}
                    setStartDate={(value) => {
                        dispatch(setDonationStartDate(value));
                    }}
                    endDate={searchKeys.donationEndDate}
                    setEndDate={(value) => {
                        dispatch(setDonationEndDate(value));
                    }}
                    stackProps={{
                        flex: 1,
                        minWidth: 0,
                        height: 42,
                        px: 1.25,
                        borderRadius: "6px 0px 0px 6px",
                        border: "1px solid #dddddd",
                    }}
                    rangeProps={{
                        displayFormat: "DD MMM YYYY",
                    }}
                />
                <GlobalButton
                    endIcon={<SearchIcon />}
                    handleClickBtn={() => {
                        dispatch(setDonationCurrentPage(1));
                        fetchData?.(
                            searchKeys.donationOrganization,
                            pagination.page,
                            pagination.limit,
                            searchKeys.donationStartDate,
                            searchKeys.donationEndDate,
                        );
                    }}
                    styleProps={{
                        color: "primary",
                        width: "auto",
                        borderRadius: "0px 6px 6px 0px",
                        minWidth: 45,
                        height: "42px",
                        "& .MuiButton-icon": {
                            marginLeft: "0px",
                        },
                    }}
                />
            </Stack>
        </Stack>
    );
};

export default DonationFilters;
